import { useCallback } from 'react';

import { useMqttJwtController_generateEmqxToken } from '@/services/hooks';

import { toEmqxToken } from './mappers';
import type { EmqxToken } from './types';

/**
 * Asks the backend for a broker token allowing publish and subscribe on every topic. The
 * backend sets the username and the expiry; the client must not send `expiresIn`.
 */
export function useGenerateEmqxToken(): () => Promise<EmqxToken> {
    const { mutateAsync } = useMqttJwtController_generateEmqxToken();
    return useCallback(async () => {
        const response = await mutateAsync({
            requestBody: {
                acl: [
                    { permission: 'allow', action: 'publish', topic: '#' },
                    { permission: 'allow', action: 'subscribe', topic: '#' },
                ],
            },
        });
        return toEmqxToken(response.data);
    }, [mutateAsync]);
}
